/**
 * Blur focus inside a MUI temporary Drawer before it receives aria-hidden on close.
 * Must run synchronously (or in useLayoutEffect) — Modal's useEffect sets aria-hidden
 * after paint if focus is still on the paper.
 */
export function blurFocusInsideDrawer() {
  const { activeElement } = document;
  if (!(activeElement instanceof HTMLElement)) return;

  const drawerPaper = activeElement.closest('.MuiDrawer-paper');
  if (!drawerPaper) return;

  activeElement.blur();
}

export default blurFocusInsideDrawer;
